// extracted by mini-css-extract-plugin
export default {"form":"formStep_form__0k8+D","double":"formStep_double__OBkUf","result":"formStep_result__2zmJ2","button":"formStep_button__hPTkG"};